import H from 'highcharts'
//TODO improve handling of highcharts

export default {
  yAxis: {
    labels: {
      formatter() {
        const {investmentValue = 1} = this.chart.options.presetData
        const val = (this.value * investmentValue / 100 + investmentValue)
        return H.numberFormat(val, -1)
      }
    }
  },
  plotOptions: {
    series: {
      compare: 'percent'
    }
  },
  tooltip: {
    pointFormatter: function () {
      const {investmentValue = 1, currency} = this.series.chart.options.presetData
      const  {valuePrefix='', valueSuffix=currency || '', valueDecimals=2} = this.series?.tooltipOptions
      const val = investmentValue + investmentValue / 100 * this.change
      return `<span style="color:${this.series.color}">\u25CF</span>${this.series.name}: ${valuePrefix+H.numberFormat(val, valueDecimals)+valueSuffix}`
    },
  }
}
